import Store from 'redux/Store'
import { setMessage } from 'redux/actions'
import ModalConfigProps from '../types/ModalConfigProps'

interface prepareSubmitFormFromModalProps {
  submitForm: Function
  data: any
  setShowOverlay: Function
  id: string | undefined
  name: string
  successNav: string
  setError?: Function
  extraData?: any
  modalConfig: ModalConfigProps
}

const prepareSubmitFormFromModal = async (props: prepareSubmitFormFromModalProps) => {
  props.setShowOverlay(true)
  props.modalConfig.setIsRequestLoading(true)
  props
    .submitForm({
      data: props.data,
      setShowOverlay: props.setShowOverlay,
      id: props.id,
      setError: props?.setError,
      extraData: props.extraData,
    })
    .then((response: any) => {
      if (response?.status === 200 || response?.status === 201) {
        Store.dispatch(setMessage(props.name + ' successfully saved.', 'success', 'instant'))

        props.modalConfig.triggerDataUpdate()
      }

      props.setShowOverlay(false)
    })
  props.modalConfig.setIsRequestLoading(false)
  return true
}

export default prepareSubmitFormFromModal
